import { render, staticRenderFns } from "./DigitsArea.vue?vue&type=template&id=a0cc198a&scoped=true&lang=pug&"
import script from "./DigitsArea.vue?vue&type=script&lang=js&"
export * from "./DigitsArea.vue?vue&type=script&lang=js&"
import style0 from "./DigitsArea.vue?vue&type=style&index=0&id=a0cc198a&scoped=true&lang=scss&"
import style1 from "./DigitsArea.vue?vue&type=style&index=1&id=a0cc198a&lang=scss&scoped=true&"
import style2 from "./DigitsArea.vue?vue&type=style&index=2&id=a0cc198a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cc198a",
  null
  
)

export default component.exports